// extracted by mini-css-extract-plugin
module.exports =  {"tabsContainer":"tabsContainer_aOGxNGY8","carbonTabsContainer":"carbonTabsContainer_dPCYx40r"};